/**
 * Sådan ser mailen ud forskellige steder.
 *
 * Det her er en EFTERLIGNING, ikke en rigtig Outlook. Den bygger på de forskelle, der er kendte og
 * dokumenterede mellem mailprogrammerne, og den viser dem på den bredde, programmet typisk har. Den kan
 * fange de fejl, der plejer at opstå - en knap der falder fra hinanden, en mobiltilpasning der ikke virker -
 * men den er ikke et bevis. Den endelige prøve er at sende en testmail til en rigtig adresse.
 *
 * Kilderne til forskellene:
 * - Outlook på Windows sætter mailen op med Word. Word kan ikke <style>, altså heller ikke mobiltilpasning,
 *   og kan ikke afrundede hjørner. Roboto findes ikke på Windows, så der bruges Arial.
 * - Gmail erstatter skrifttyper, den ikke selv har, og forkorter mails over ca. 102 KB med et "Vis hele
 *   beskeden"-link.
 * - Apple Mail på Mac og iPhone viser mailen som en browser ville. Den er den mest tilgivende.
 * - Gmail-appen på Android kan mobiltilpasning og viser Roboto, som er systemets egen skrift.
 */

export type MailClient = "appleMail" | "iphone" | "android" | "gmail" | "outlook";

export const MAIL_CLIENTS: MailClient[] = ["appleMail", "gmail", "outlook", "iphone", "android"];

/** Bredden mailen vises i, som i programmets eget vindue */
export const clientWidth: Record<MailClient, number> = {
  appleMail: 680,
  gmail: 640,
  outlook: 620,
  iphone: 390,
  android: 412,
};

/** Telefonerne vises i en ramme, så det er til at se, at det er en lille skærm */
export const isPhone = (client: MailClient) => client === "iphone" || client === "android";

/** Gmail forkorter mails, der fylder mere end det her */
const GMAIL_LIMIT = 102 * 1024;

export const clippedByGmail = (html: string, client: MailClient) => client === "gmail" && new Blob([html]).size > GMAIL_LIMIT;

/** Mailen, som det valgte program ville vise den */
export const asClient = (html: string, client: MailClient): string => {
  if (client === "outlook") {
    return (
      html
        // Word læser ikke <style>, så mobiltilpasningen sker ikke - heller ikke på en lille skærm
        .replace(/<style>[\s\S]*?<\/style>/g, "")
        // ... men det, der står i <!--[if mso]-->, er netop kun til Outlook
        .replace(/<!--\[if mso\]>([\s\S]*?)<!\[endif\]-->/g, "$1")
        .replace(/border-radius:[^;"]*;?/g, "")
        .replace(/Roboto,\s*Arial/g, "Arial")
    );
  }
  if (client === "gmail") {
    // Gmail bruger sin egen skrift, når den, mailen beder om, ikke findes
    return html.replace(/Roboto,\s*Arial/g, "Arial");
  }
  // Apple Mail og Gmail-appen på Android viser mailen, som den er skrevet
  return html;
};
